<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 门票管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                        type="primary"
                        icon="el-icon-delete"
                        class="handle-del mr10"
                        @click="delAllSelection"
                >批量删除
                </el-button>-->
                <el-select class="handle-select mr10 wd200" clearable placeholder="景点目录" v-model="search.menu">
                    <el-option :key="item.Id"
                               :label="'【'+item.cityName+'】-'+item.Sname"
                               :value="item.Id"
                               v-for="item in sceOpt.city"></el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="门票关键字" v-model="search.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getTicketData" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="id" sortable width="65"></el-table-column>
                <el-table-column label="门票标题" prop="tname" sortable></el-table-column>
                <el-table-column label="所属景区" prop="scenic.Sname" sortable></el-table-column>
                <el-table-column align="center" label="门票状态" sortable>
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.tstate===0?'danger':(scope.row.tstate===1?'success':'info')"
                        >{{scope.row.tstate===0?'屏蔽中':(scope.row.tstate===1?'正显示':'正推荐')}}
                        </el-tag>
                    </template>
                </el-table-column>
<!--                <el-table-column align="center" label="价格标准" prop="tprice_stand"></el-table-column>-->
                <el-table-column align="center" label="最近更新" prop="tupdate_time" sortable width="168"></el-table-column>
                <el-table-column align="center" label="排序编号" prop="torder" sortable></el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <!--<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>
            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" title="编辑门票信息" width="50%">
            <el-form :model="form" label-width="100px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="12">
                <el-form-item label="门票名称/标题">
                    <el-input class="wd200" v-model="form.tname"></el-input>
                </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排序编号">
                            <el-input class="wd200" v-model="form.torder"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="所属景点">
                            <el-select filterable placeholder="请选择" v-model="form.tpid">
                                <el-option
                                        :key="item.Id"
                                        :label="'【'+item.cityName+'】-'+item.Sname"
                                        :value="item.Id"
                                        v-for="item in scenicList">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="售卖状态">
                            <el-select placeholder="请选择" v-model="form.tstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in sceOpt.state"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="散客结算：">
                            <el-input class="wd200" v-model="form.tprice_peerN"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="团队结算：">
                            <el-input class="wd200" v-model="form.tprice_teamN"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="散客政策">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="4"
                            show-word-limit
                            type="textarea"
                            v-model="form.tprice_peerN_policy"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="团队政策">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="4"
                            show-word-limit
                            type="textarea"
                            v-model="form.tprice_teamN_policy"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item label="对外说明">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="6"
                            show-word-limit
                            type="textarea"
                            v-model="form.tnote_externalN"
                    >
                    </el-input>
                </el-form-item>

                <el-row :gutter="20" style="background-color: coral">
                    <el-col :span="12">
                <el-form-item label="VIP散客价：">
                    <el-input class="wd200" v-model="form.tprice_peer"></el-input>
                </el-form-item>
                    </el-col>
                    <el-col :span="12">
                <el-form-item label="VIP团队价：">
                    <el-input class="wd200" v-model="form.tprice_team"></el-input>
                </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="VIP散客政策">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="4"
                            show-word-limit
                            type="textarea"
                            v-model="form.tprice_peer_policy"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="VIP团队政策">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="4"
                            show-word-limit
                            type="textarea"
                            v-model="form.tprice_team_policy"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item label="VIP对外说明">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="6"
                            show-word-limit
                            type="textarea"
                            v-model="form.tnote_external"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item label="对内说明">
                    <el-input
                            maxlength="255"
                            placeholder="请输入内容"
                            rows="6"
                            show-word-limit
                            type="textarea"
                            v-model="form.tnote_internal"
                    >
                    </el-input>
                </el-form-item>


                <!--<el-form-item label="网络成人价格">
                    <el-input class="wd200" v-model="form.tprice_adult_online"></el-input>
                </el-form-item>
                <el-form-item label="网络优惠价格">
                    <el-input class="wd200" v-model="form.tprice_savers_online"></el-input>
                </el-form-item>
                <el-form-item label="团队价格">
                    <el-input class="wd200" v-model="form.tprice_team"></el-input>
                </el-form-item>
                <el-form-item label="散客价格">
                    <el-input class="wd200" v-model="form.tprice_personal"></el-input>
                </el-form-item>

                <el-form-item label="计费方式">
                    <el-input
                            maxlength="300"
                            placeholder="请输入内容"
                            rows="3"
                            show-word-limit
                            type="textarea"
                            v-model="form.tprice_method"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="价格标准">
                    <el-input
                            maxlength="300"
                            placeholder="请输入内容"
                            rows="3"
                            show-word-limit
                            type="textarea"
                            v-model="form.tprice_stand"
                    >
                    </el-input>
                </el-form-item>-->
            </el-form>
            <span slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                sceOpt: {
                    city: [],
                    star: [{
                        value: 1,
                        label: 'A'
                    }, {
                        value: 2,
                        label: 'AA'
                    }, {
                        value: 3,
                        label: 'AAA'
                    }, {
                        value: 4,
                        label: 'AAAA'
                    }, {
                        value: 5,
                        label: 'AAAAA'
                    }, {
                        value: 0,
                        label: '暂未评级'
                    }],
                    state: [{
                        value: 0,
                        label: '屏蔽中'
                    }, {
                        value: 1,
                        label: '正显示'
                    }, {
                        value: 2,
                        label: '正推荐'
                    }],
                    free: {}
                },
                search: {
                    keyword: '',
                    menu: '',
                    sdid: sessionStorage.getItem('ml_cityId')
                },
                show: {
                    page: true,
                    search: false
                },
                query: {
                    address: '',
                    name: '',
                    pageIndex: 1,
                    pageSize: 15,
                    sdid: sessionStorage.getItem('ml_cityId'),
                    state: 1
                },
                //destCity: { cityId: 17 },
                scenicList: [],
                tableData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            // this.reload();
            this.getTicketData();

        },
        methods: {
            //门票列表数据
            async getTicketData() {
                const { data: res } = await this.$http.post('admin/tickets/initTicketData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取数据失败，请联系管理员!');
                }
                this.sceOpt.city = res.menu;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 25;
                this.show.page = true;
                this.show.search = false;
                this.search.keyword = '';
                this.search.menu = '';
                this.$message.success('【门票数据】加载成功!');
            },
            //获取景点列表  (新增门票数据时会用到)
            async getScenic() {
                const { data: res } = await this.$http.get('/admin/tickets/getDestScenic', {
                    params: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.scenicList = res.scenics;
            },
            // 触发搜索按钮
            async handleSearch() {
                const { data: res } = await this.$http.post('admin/tickets/searchTicket', {
                    search: this.search
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取门票数据失败，请联系管理员!');
                }

                this.sceOpt.city = res.menu;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },
            // 删除操作
            handleDelete(index, row) {
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.$message.success('删除成功');
                        this.tableData.splice(index, 1);
                    })
                    .catch(() => {
                    });
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },


            // 编辑门票 操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
                this.getScenic();
            },

            // 保存门票 操作
            async saveEdit() {
                this.editVisible = false;
                this.form['userId'] = localStorage.getItem('ml_userid');
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/tickets/addTicket', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改门票失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getTicketData();
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
